<script>
	import { Form, Row, Col, Button } from "sveltestrap";
	// import CustomInput from "../CustomInput/CustomInput.svelte";
	import { Sveltik, Field } from "sveltik";
	// import { navigate } from "svelte-routing";
	import SveltyPicker from "svelty-picker";
	import queryString from "query-string";
	import {
		estateOptions,
		fuelTypeOptions,
		jobOptions,
		regionOptions,
		jobStatusOptions,
		userStatusOptions,
		groupStatusOptions,
		carStatusOptions,
		reportStatusOptions,
		reportSectionOptions,
		carSectionOptions,
		damageTypeOptionsSelect,
		carparkStatusOptions,
		fmsUserStatusOptions,
	} from "../../utils/options";
	import { masterData, trigerBlackoutSearch } from "../../store/store";

	const query = queryString.parse(window.location.search);

	let initialValues = {
		stationId: query.stationId || "",
		jobType: query.jobType || "",
		region: query.region || "",
		estate: query.estate || "",
		status: query.status || "",
		jobReferenceId: query.jobReferenceId || "",
		code: query.code || "",
		vehicleNumber: query.vehicleNumber || "",
		vehicleNumberVI: query.vehicleNumber || "",
		taskType: query.taskType || "",
		fuelTypeId: query.fuelTypeId || "",
		incompleteReason: query.incompleteReason || "",
		endDateRange: query.endDateRange || null,
		startDateRange: query.startDateRange || null,
		BlackoutStartTime: query.BlackoutStartTime || null,
		BlackoutEndTime: query.BlackoutEndTime || null,
		name: query.name || "",
		mobileNumber: query.mobileNumber || "",
		email: query.email || "",
		description: query.description || "",
		minIncentive: query.minIncentive || "",
		maxIncentive: query.maxIncentive || "",
		PriceGroupId: query.PriceGroupId || "",
		carMake: query.carMake || "",
		carModel: query.carModel || "",
		carStatus: query.carStatus || "",
		evStatus: query.evStatus || "",
		carColor: query.carColor || "",
		carparkStatus: query.carparkStatus || "",
		plateNumber: query.plateNumber || "",
		addressQuery: query.addressQuery || "",
		keyword: query.keyword || "",
		CarPlateNumber: query.CarPlateNumber || "",
		carpark: query.carpark || "",
		fuelCompany: query.fuelCompany || "",
		fuelCompanyId: query.fuelCompanyId || "",
		EVCompanyId: query.EVCompanyId || "",
		search: query.search || "",
		reportStatus: query.reportStatus || "",
		reportSection: query.reportSection || "",
		carSection: query.carSection || "",
		damageType: query.damageType || "",
		rejectReason: query.rejectReason || "",
		userMobileNumber: query.userMobileNumber || "",
		carAssetOwnerId: query.carAssetOwnerId || "",
		isActive: query.isActive || "",
		taskCategoryId: query.taskCategoryId || "",
	};
	let startDate;
	let endDate;
	let boStartDate; // blackout start date
	let boEndDate; // blackout end date
	let myDateStart = "";
	let myDateEnd = "";

	export let stationId = false;
	export let jobReferenceId = false;
	export let taskReferenceId = false;
	export let vehicleNumber = false;
	export let vehicleNumberVI = false;
	export let region = false;
	export let estate = false;
	export let jobType = false;
	export let status = false;
	export let incompleteReason = false;
	export let startDateRange = false;
	export let endDateRange = false;
	export let BlackoutStartTime = false;
	export let BlackoutEndTime = false;
	export let name = false;
	export let mobileNumber = false;
	export let email = false;
	export let description = false;
	export let fuelType = false;
	export let taskType = false;
	export let incentive = false;
	export let statusName = false;
	export let userStatus = false;
	export let fmsUserStatus = false;
	export let groupStatus = false;
	export let jobStatus = false;
	export let searchParameter = false;
	export let carStatus = false;
	export let evStatus = false;
	export let priceGroup = false;
	export let carMake = false;
	export let carModel = false;
	export let plateNumber = false;
	export let addressQuery = false;
	export let keyword = false;
	export let reportStatus = false;
	export let reportSection = false;
	export let carSection = false;
	export let damageType = false;
	export let CarPlateNumber = false;
	export let carpark = false;
	export let fuelCompany = false;
	export let fuelCompanyId = false;
	export let EVCompanyId = false;
	export let blackoutSearch = false;
	export let alignItem;
	export let carparkStatus = false;
	export let vehicleColor = false;
	export let rejectReason = false;
	export let userMobileNumber = false;
	export let carAssetOwner = [];
	export let taskCategoryId = [];
	export let isActive = null;

	function handleSubmit(values) {
		// let d = startDate.toISOString().split("T")[0];
		if (startDate) {
			values.startDateRange = startDate;
		} else {
			values.startDateRange = "";
		}

		// let d = endDate.toISOString().split("T")[0];
		if (endDate) {
			values.endDateRange = endDate;
		} else {
			values.endDateRange = "";
		}

		let params = {};
		for (let key in values) {
			if (values[key] && values[key] !== "") {
				params[key] = values[key];
			}
		}
		var newRelativePathQuery =
			window.location.pathname + "?" + new URLSearchParams(params);
		if (blackoutSearch) {
			trigerBlackoutSearch.set(false);
			window.history.replaceState(
				null,
				null,
				window.location.origin + newRelativePathQuery
			);
			trigerBlackoutSearch.set(true);
		} else {
			// navigate(window.location.origin + newRelativePathQuery, { replace: true });
			window.location.replace(
				window.location.origin + newRelativePathQuery
			);
		}
	}
</script>

<Sveltik {initialValues} onSubmit={handleSubmit} let:props>
	<form on:submit|preventDefault={props.handleSubmit} class="w-100">
		<Row className="mx-0">
			<Col xs={9} class="">
				<Row>
					{#if description}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="description"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder=" Description"
								value={props.values.description}
							/>
						</Col>
					{/if}

					{#if jobReferenceId}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="jobReferenceId"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by Job ID"
								value={props.values.jobReferenceId}
							/>
						</Col>
					{/if}
					{#if taskReferenceId}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="code"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder=" Task reference ID"
								value={props.values.code}
							/>
						</Col>
					{/if}
					{#if vehicleNumberVI}
						<Col xs={12}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="vehicleNumber"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by vehicle no."
								value={props.values.vehicleNumber}
							/>
						</Col>
					{/if}
					{#if vehicleNumber}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="vehicleNumber"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by vehicle no."
								value={props.values.vehicleNumber}
							/>
						</Col>
					{/if}
					{#if rejectReason}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1 pb-2"
								name="rejectReason"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by reject reason"
								value={props.values.rejectReason}
							/>
						</Col>
					{/if}
					{#if reportSection}
						<Col xs={6}>
							<Field
								name="reportSection"
								as="select"
								class="form-select getgo select my-1 "
							>
								{#each reportSectionOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}
					{#if carSection}
						<Col xs={6}>
							<Field
								name="carSection"
								as="select"
								class="form-select getgo select my-1 "
							>
								{#each carSectionOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}
					{#if damageType}
						<Col xs={6}>
							<Field
								name="damageType"
								as="select"
								class="form-select getgo select my-1 "
							>
								{#each damageTypeOptionsSelect as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}

					{#if plateNumber}
						<Col xs={12}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="plateNumber"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by vehicle plate"
								value={props.values.plateNumber}
							/>
						</Col>
					{/if}
					{#if addressQuery}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="addressQuery"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by address"
								value={props.values.addressQuery}
							/>
						</Col>
					{/if}
					{#if keyword}
						<Col xs={12}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="keyword"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by id, name, address, postal code"
								value={props.values.keyword}
							/>
						</Col>
					{/if}
					{#if CarPlateNumber}
						<Col xs={12}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="CarPlateNumber"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by vehicle plate"
								value={props.values.CarPlateNumber}
							/>
						</Col>
					{/if}
					{#if carpark}
						<Col xs={6}>
							<Field
								name="carpark"
								as="select"
								class="form-select getgo select my-1 "
							>
								<option value="">All Carparks</option>
								{#if $masterData}
									{#each $masterData?.carParks as option}
										<option value={option.id.toString()}
											>{option.name}</option
										>
									{/each}
								{/if}
							</Field>
						</Col>
					{/if}

					{#if priceGroup}
						<Col xs={6}>
							<Field
								name="PriceGroupId"
								as="select"
								class="form-select getgo select my-1 "
							>
								<option value="">All Price Group</option>
								{#if $masterData}
									{#each $masterData.priceGroups as { id, name }}
										<option value={id.toString()}
											>{name}</option
										>
									{/each}
								{/if}
							</Field>
						</Col>
					{/if}

					{#if carMake}
						<Col xs={6}>
							<Field
								name="carMake"
								as="select"
								class="form-select getgo select my-1 "
							>
								<option value="">All Vehicle Makes</option>
								{#if $masterData}
									{#each $masterData.vehicleMakes as option}
										<option value={option.id.toString()}
											>{option.name}</option
										>
									{/each}
								{/if}
							</Field>
						</Col>
					{/if}
					{#if carModel}
						<Col xs={6}>
							<Field
								name="carModel"
								as="select"
								class="form-select getgo select my-1 "
							>
								<option value="">All Vehicle Models</option>
								{#if $masterData}
									{#each $masterData.vehicleModels as option}
										<option value={option.id}
											>{option.name}</option
										>
									{/each}
								{/if}
							</Field>
						</Col>
					{/if}
					{#if vehicleColor}
						<Col xs={6}>
							<Field
								name="carColor"
								as="select"
								class="form-select getgo select my-1 "
							>
								<option value="">All Vehicle Color</option>
								{#if $masterData}
									{#each $masterData.vehicleColors as option}
										<option value={option.id}
											>{option.name}</option
										>
									{/each}
								{/if}
							</Field>
						</Col>
					{/if}
					{#if carStatus}
						<Col xs={6}>
							<Field
								name="carStatus"
								as="select"
								class="form-select getgo select my-1 "
							>
								{#each carStatusOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}

					{#if evStatus}
						<Col xs={6}>
							<Field
								name="evStatus"
								as="select"
								class="form-select getgo select my-1 "
							>
								{#each carStatusOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}

					{#if fuelCompany}
						<Col xs={6}>
							<Field
								name="fuelCompany"
								as="select"
								class="form-select getgo select my-1 "
							>
								<option value="">All fuel companies</option>
								{#if $masterData}
									{#each $masterData.fuelCompanies as option}
										<option value={option.id.toString()}
											>{option.name}</option
										>
									{/each}
								{/if}
							</Field>
						</Col>
					{/if}

					{#if fuelCompanyId}
						<Col xs={6}>
							<Field
								name="fuelCompanyId"
								as="select"
								class="form-select getgo select my-1 "
							>
								<option value="">All fuel companies</option>
								{#if $masterData}
									{#each $masterData.fuelCompanies as option}
										<option value={option.id.toString()}
											>{option.name}</option
										>
									{/each}
								{/if}
							</Field>
						</Col>
					{/if}

					{#if EVCompanyId}
						<Col xs={6}>
							<Field
								name="EVCompanyId"
								as="select"
								class="form-select getgo select my-1 "
							>
								<option value="">All EV companies</option>
								{#if $masterData}
									{#each $masterData.cpoProviders as option}
										<option value={option.id.toString()}
											>{option.name}</option
										>
									{/each}
								{/if}
							</Field>
						</Col>
					{/if}

					{#if name}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="name"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by name"
								value={props.values.name}
							/>
						</Col>
					{/if}
					{#if mobileNumber}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="mobileNumber"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Mobile no. (without country code)"
								value={props.values.mobileNumber}
							/>
						</Col>
					{/if}
					{#if stationId}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="stationId"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by Station ID"
								value={props.values.stationId}
							/>
						</Col>
					{/if}

					{#if region}
						<Col xs={6}>
							<Field
								name="region"
								as="select"
								class="form-select getgo select my-1"
							>
								<option value="">All region</option>
								{#each regionOptions as option}
									<option value={option.label}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}
					{#if taskType}
						<Col xs={6}>
							<Field
								name="taskType"
								as="select"
								class="form-select getgo select my-1"
							>
								{#each jobOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}

					{#if fuelType}
						<Col xs={6}>
							<Field
								name="fuelTypeId"
								as="select"
								class="form-select getgo select my-1"
							>
								<option value="">All fuel type</option>

								{#each fuelTypeOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}
					{#if estate}
						<Col xs={6}>
							<Field
								name="estate"
								as="select"
								class="form-select getgo select my-1"
							>
								{#each estateOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}
					{#if incompleteReason}
						<Col xs={12}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="incompleteReason"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by blocking reason"
								value={props.values.incompleteReason}
							/>
						</Col>
					{/if}
				</Row>
				<Row class="">
					{#if jobType}
						<Col xs={6}>
							<Field
								name="jobType"
								as="select"
								class="form-select getgo select my-1 "
							>
								{#each jobOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}
					{#if email}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="email"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by email"
								value={props.values.email}
							/>
						</Col>
					{/if}

					{#if userMobileNumber}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="userMobileNumber"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Mobile no. (without country code)"
								value={props.values.userMobileNumber}
							/>
						</Col>
					{/if}

					{#if status}
						<Col xs={6}>
							<Field
								name="status"
								as="select"
								class="form-select getgo select my-1"
							>
								{#if fmsUserStatus}
									{#each fmsUserStatusOptions as option}
										<option value={option.value}
											>{option.label}</option
										>
									{/each}
								{:else if userStatus}
									{#each userStatusOptions as option}
										<option value={option.value}
											>{option.label}</option
										>
									{/each}
								{:else if jobStatus}
									{#each jobStatusOptions as option}
										<option value={option.value}
											>{option.label}</option
										>
									{/each}
								{:else if groupStatus}
									{#each groupStatusOptions as option}
										<option value={option.value}
											>{option.label}</option
										>
									{/each}
								{:else if reportStatus}
									{#each reportStatusOptions as option}
										<option value={option.value}
											>{option.label}</option
										>
									{/each}
								{/if}
							</Field>
						</Col>
					{/if}

					{#if searchParameter}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="search"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Input Name, Email, or Mobile number here"
								value={props.values.search}
							/>
						</Col>
					{/if}
					{#if statusName}
						<Col xs={6}>
							<input
								type="text"
								class="form-control getgo input my-1"
								name="name"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								placeholder="Search by name"
								value={props.values.name}
							/>
						</Col>
						<Col xs={6}>
							<Field
								name="status"
								as="select"
								class="form-select getgo select my-1"
							>
								{#each groupStatusOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}
					{#if carparkStatus}
						<Col xs={6}>
							<Field
								name="carparkStatus"
								as="select"
								class="form-select getgo select my-1 "
							>
								{#each carparkStatusOptions as option}
									<option value={option.value}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}
					{#if BlackoutStartTime}
						<Col xs={6}>
							<SveltyPicker
								inputClasses="form-control getgo input my-1  "
								format="yyyy-mm-dd"
								bind:value={myDateStart}
								placeholder="Blackout start date"
								on:change={(e) => (boStartDate = e.detail)}
							/>
						</Col>
					{/if}

					{#if BlackoutEndTime}
						<Col xs={6}>
							<SveltyPicker
								inputClasses="form-control getgo input my-1 "
								format="yyyy-mm-dd"
								bind:value={myDateEnd}
								placeholder="Blackout end date"
								on:change={(e) => (boEndDate = e.detail)}
							/>
						</Col>
					{/if}

					{#if incentive}
						<Col xs={12} class="d-flex align-items-center ">
							<!-- <label for="incentive">
								<span class="mr-2">Incentive</span>
							</label> -->
							<input
								type="text"
								class="form-control getgo input my-1"
								name="minIncentive"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								value={props.values.minIncentive}
								placeholder="Min incentive"
							/>
							&nbsp;-&nbsp;
							<input
								type="text"
								class="form-control getgo input my-1"
								name="maxIncentive"
								on:input={props.handleInput}
								on:blur={props.handleBlur}
								value={props.values.maxIncentive}
								placeholder="Max incentive"
							/>
						</Col>
					{/if}
				</Row>
				<Row class="">
					{#if startDateRange}
						<Col xs={6}>
							<SveltyPicker
								inputClasses="form-control getgo input my-1"
								format="yyyy-mm-dd"
								bind:value={myDateStart}
								placeholder={jobStatus
									? "Created/Assigned At Date After"
									: "Start date range"}
								on:change={(e) =>
									e.detail
										? (startDate = e.detail)
										: (startDate = "")}
							/>
						</Col>
					{/if}
					{#if endDateRange}
						<Col xs={6}>
							<SveltyPicker
								inputClasses="form-control getgo input my-1"
								format="yyyy-mm-dd"
								bind:value={myDateEnd}
								placeholder={jobStatus
									? "Created/Assigned At Date Before"
									: "End date range"}
								on:change={(e) =>
									e.detail
										? (endDate = e.detail)
										: (endDate = "")}
							/>
						</Col>
					{/if}
					{#if carAssetOwner.length > 0}
						<Col xs={12}>
							<Field
								name="carAssetOwnerId"
								as="select"
								class="form-select getgo select my-1 "
							>
								<option value=""
									>{"All Vehicle Asset Owners"}</option
								>
								{#each carAssetOwner as option}
									<option value={option.id.toString()}
										>{option.name}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}
					{#if isActive}
						<Col xs={6}>
							<Field
								name="isActive"
								as="select"
								class="form-select getgo select my-1 "
							>
								<option value="">All</option>
								<option value={"1"}>Active</option>
								<option value={"0"}>Inactive</option>
							</Field>
						</Col>
					{/if}
					{#if taskCategoryId.length > 0}
						<Col xs={6}>
							<Field
								name="taskCategoryId"
								as="select"
								class="form-select getgo select my-1 "
							>
								<option value="">All Task Categories</option>
								{#each taskCategoryId as option}
									<option value={option.value.toString()}
										>{option.label}</option
									>
								{/each}
							</Field>
						</Col>
					{/if}
				</Row>
			</Col>

			<Col xs={3} class="d-flex align-self-end my-1 ">
				<Button
					class="themeButton primary"
					type="submit"
					style="z-index: 1000">Search</Button
				>
			</Col>
			<!-- <Row class="">
					<Col>
						<Flatpickr />
					</Col>
				</Row> -->
			<!-- <Row>
					<Button type="submit">Search</Button>
				</Row> -->
		</Row>
	</form>
</Sveltik>
